import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const NavMenu = () => {

  const [visitantes, setVisitantes] = useState(false);
  const [investigadores, setInvestigadores] = useState(false);
  const [estudiantes, setEstudiantes] = useState(false);
  const [comunidad, setComunidad] = useState(false);
  const [menuMobileButton, setmenuMobileButton] = useState(false);

  const [activeNav, setactiveNav] = useState(false);

  useEffect(() => {
    
    setTimeout(() => {
      setactiveNav(true)
    }, 500);
  }, [])
  

  return (
    <nav className="navbar navbar-expand-lg bg-light navStyleEdit" style={{ display: `${(activeNav) ? "flex" : "none"}` }}>
      <div className="container-fluid inNavBarDesktop">
        <Link className="navbar-brand" to='/catalogo'>
          <img src="./assets/img/logogris.png" alt="Logo" />
        </Link>
        <div className='linksCentral'>
          <div className='itemListLink'>
            <div className='item visitante' onClick={() => {setVisitantes(!visitantes); setInvestigadores(false); setEstudiantes(false); setComunidad(false);}}>
              Visitantes
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"submenuTwo " + (visitantes ? 'animate__animated animate__fadeIn' : "invisible")}>
              <div className='subItem'>
                <span>
                  Información para el turista
                </span>
                <div className='separator' />
                <a href="https://www.elbrujo.pe/visitantes/normas" rel="noopener noreferrer">
                  Normas
                </a>
                <a href="https://www.elbrujo.pe/visitantes/horario-tarifas" rel="noopener noreferrer">
                  Horarios
                </a>
                <a href="https://www.elbrujo.pe/visitantes/como-llegar" rel="noopener noreferrer">
                  ¿Como llegar?
                </a>
                <a href="https://www.elbrujo.pe/visitantes/reservas" rel="noopener noreferrer">
                  Reservas
                </a>
              </div>
              <div className='subItem'>
                <span>
                  Recorridos virtuales
                </span>
                <a href="https://www.elbrujo.pe/visitantes/ruta-clasica" rel="noopener noreferrer">
                  Ruta clásica
                </a>
                <a href="https://www.elbrujo.pe/visitantes/ruta-mistica" rel="noopener noreferrer">
                  Ruta mística
                </a>
                <a href="https://www.elbrujo.pe/visitantes/ruta-especializada" rel="noopener noreferrer">
                  Ruta especializada
                </a>
                <a href="https://www.elbrujo.pe/visitantes/ruta-museo" rel="noopener noreferrer">
                  Museo de sitio
                </a>
                <a href="https://www.elbrujo.pe/visitantes/ruta-pueblo" rel="noopener noreferrer">
                  Conoce el pueblo
                </a>
              </div>
            </div>
          </div>
          <div className='itemListLink'>
            <div className='item investigadores' onClick={() => {setInvestigadores(!investigadores); setVisitantes(false); setEstudiantes(false); setComunidad(false);}}>
              Investigadores
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"submenuOne " + (investigadores ? 'animate__animated animate__fadeIn' : "invisible")}>
              <div className='subItem'>
                <a href="https://www.elbrujo.pe/investigadores/consejo-consultivo" rel="noopener noreferrer">
                  Consejo Consultivo
                </a>
                <a href="https://www.elbrujo.pe/investigadores/equipo" rel="noopener noreferrer">
                  Equipo de Investigaciones
                </a>
                <Link to='/catalogo'>
                  Catálogo de Piezas Arqueológicas
                </Link>
                <a href="https://www.elbrujo.pe/investigadores/eventos" rel="noopener noreferrer">
                  Eventos culturales
                </a>
                <a href="https://www.elbrujo.pe/investigadores/investigacion" rel="noopener noreferrer">
                  Investigación y Publicaciones
                </a>
              </div>
            </div>
          </div>
          <div className='itemListLink'>
            <div className='item estudiantes' onClick={() => {setEstudiantes(!estudiantes); setVisitantes(false); setInvestigadores(false); setComunidad(false);}}>
              Estudiantes
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"submenuFive " + (estudiantes ? 'animate__animated animate__fadeIn' : "invisible")}>
              <div className='subItem'>
                <span>
                  Señora de Cao
                </span>
                <a href="https://www.elbrujo.pe/senora-de-cao-historia" rel="noopener noreferrer">
                  Historia
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/desenfardado" rel="noopener noreferrer">
                  Desenfardado
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/reconstruccion" rel="noopener noreferrer">
                  Reconstrucción de su rostro
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/replica" rel="noopener noreferrer">
                  Réplica de su cuerpo momificado
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/descubridor" rel="noopener noreferrer">
                  Régulo Franco, descubridor de la señora de Cao
                </a>
              </div>
              <div className='subItem'>
                <span>
                  Espacios Culturales
                </span>
                <a href="https://www.elbrujo.pe/estudiantes/museocao" rel="noopener noreferrer">
                  Museo de sitio
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/caoviejo" rel="noopener noreferrer">
                  Huaca Cao Viejo
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/huacaprieta" rel="noopener noreferrer">
                  Huaca Prieta
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/huaca-cortada" rel="noopener noreferrer">
                  Huaca Cortada
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/pozoceremonial" rel="noopener noreferrer">
                  Pozo Ceremonial
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/paredones" rel="noopener noreferrer">
                  Paredones
                </a>
              </div>
              <div className='subItem'>
                <span>
                  Contenidos del Antiguo Perú
                </span>
                <a href="https://www.elbrujo.pe/estudiantes/descubriendo-nuestra-historia" rel="noopener noreferrer">
                  Descubriendo Nuestra Historia
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/acceso-permitido" rel="noopener noreferrer">
                  El Brujo, acceso permitido
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/antiguo-peru" rel="noopener noreferrer">
                  El Antiguo Perú, la mirada de los especialistas
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/talleres" rel="noopener noreferrer">
                  Talleres virtuales
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/infografia" rel="noopener noreferrer">
                  Infografías
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/articulos" rel="noopener noreferrer">
                  Articulos
                </a>
              </div>
              <div className='subItem'>
                <span>
                  Juega en casa
                </span>
                <a href="https://www.elbrujo.pe/estudiantes/rompecabezas" rel="noopener noreferrer">
                  Rompecabezas
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/trivias" rel="noopener noreferrer">
                  Trivias
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/memoriza" rel="noopener noreferrer">
                  Memoriza
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/crucigramas" rel="noopener noreferrer">
                  Crucigramas
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/sopa" rel="noopener noreferrer">
                  Sopa de letras
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/manualidades" rel="noopener noreferrer">
                  Manualidades
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/pacman" rel="noopener noreferrer">
                  Pac-Man Moche
                </a>
              </div>
              <div className='subItem'>
                <span>
                  Talleres e Inventario
                </span>
                <a href="https://www.elbrujo.pe/estudiantes/microtalleres" rel="noopener noreferrer">
                  Microtalleres
                </a>
                <a href="https://www.elbrujo.pe/estudiantes/inventario" rel="noopener noreferrer">
                  Inventario de colecciones
                </a>
              </div>
            </div>
          </div>
          <div className='itemListLink'>
            <div className='item comunidad' onClick={() => {setComunidad(!comunidad); setVisitantes(false); setInvestigadores(false); setEstudiantes(false);}}>
              Comunidad
              <ion-icon name="chevron-down-outline"></ion-icon>
            </div>
            <div className={"submenuOneC " + (comunidad ? 'animate__animated animate__fadeIn' : "invisible")}>
              <div className='subItem'>
                <a href="https://www.elbrujo.pe/comunidad" rel="noopener noreferrer">
                  Actividades
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='containtRight'>
          <div className='superior'>
            <ion-icon name="logo-youtube"></ion-icon>
            <ion-icon name="logo-twitter"></ion-icon>
            <ion-icon name="logo-facebook"></ion-icon>
            <ion-icon name="logo-instagram"></ion-icon>
            <select name="changeLanguage" id="changeLanguage">
              <option defaultValue="">Español</option>
            </select>
          </div>
          <div className='botOrder'>
            <a href="https://www.elbrujo.pe/institucional/fundacion" rel="noopener noreferrer">
              Institucional
            </a>
            <a href="https://www.elbrujo.pe/colabora" rel="noopener noreferrer">
              Colabora con El Brujo
            </a>
            <a href="https://www.elbrujo.pe/blog" rel="noopener noreferrer">
              Noticias
            </a>
          </div>
        </div>
        <div className="containMenuMobile">
          <div className='menuMobile' onClick={() => {setmenuMobileButton(!menuMobileButton)}}>
            {
              (!menuMobileButton)
                ? <ion-icon name="menu-outline"></ion-icon>
                : <ion-icon name="close-outline"></ion-icon>
            }
          </div>
          <div className={'listMenuMobile ' + ((menuMobileButton) ? 'animate__animated animate__fadeIn' : 'invisible')}>
            <div className='languageSelect'>
              <div className='item'>
                Español
              </div>
              <div className='item no-selected'>
                Inglés
              </div>
            </div>
            <div className='listaLinks'>
              <a href='https://www.elbrujo.pe/visitantes/normas' className='itemList'>
                <b>
                  Visitantes
                </b>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
              <a href='https://www.elbrujo.pe/investigadores/equipo' className='itemList'>
                <b>
                  Investigadores
                </b>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
              <a href='https://www.elbrujo.pe/senora-de-cao-historia' className='itemList'>
                <b>
                  Estudiantes
                </b>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
              <a href='https://www.elbrujo.pe/comunidad' className='itemList'>
                <b>
                  Comunidad
                </b>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
            </div>
            <div className='subListaLinks'>
              <a href="https://www.elbrujo.pe/institucional/fundacion" className='itemList'>
                <p>
                  Institucional
                </p>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
              <a href='https://www.elbrujo.pe/colabora' className='itemList'>
                <p>
                  Colabora con El Brujo
                </p>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
              <a href='https://www.elbrujo.pe/blog' className='itemList'>
                <p>
                  Noticias
                </p>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </a>
            </div>
            <div className="redes">
              <a href="https://www.youtube.com/channel/UC2RG2-Gxm6_6o7vDcTkrdZA" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-youtube"></ion-icon>
              </a>
              <a href="https://twitter.com/elbrujope" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-twitter"></ion-icon>
              </a>
              <a href="https://www.facebook.com/ComplejoArqueologicoElBrujo" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-facebook"></ion-icon>
              </a>
              <a href="https://www.instagram.com/elbrujope/" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-instagram"></ion-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
